import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import Typography from "@shared/v2/Typography";

const DeleteTagModal = ({ tag, onClose, onDelete }) => {
  const [loading, setLoading] = useState(false);
  return (
    <Modal
      show={tag}
      onHide={onClose}
      closeOnEscape={false}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-max-w-[440px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
    >
      <Modal.Header title="Delete Tag?" closeButton />

      {tag && (
        <Modal.Body className="tw-py-[8px] tw-flex tw-flex-col tw-gap-[24px] tw-overflow-auto">
          <Typography>
            Are you sure you want to delete this tag? <b>{tag.name}</b>
          </Typography>
          <Typography>
            It is applied to{" "}
            <b>
              {tag.peopleCount} {tag.peopleCount > 1 ? "people" : "person"}
            </b>
            . This action can&apos;t be undone.
          </Typography>
        </Modal.Body>
      )}

      <Modal.Footer className="tw-flex tw-justify-between tw-gap-[8px]">
        <Button schema="tertiary" size="medium" onClick={onClose}>
          Cancel
        </Button>
        <Button
          schema="warning"
          size="medium"
          isLoading={loading}
          onClick={() => {
            setLoading(true);
            onDelete(tag).finally(() => {
              setLoading(false);
            });
          }}
        >
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DeleteTagModal.propTypes = {
  tag: PropTypes.shape(),
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

DeleteTagModal.defaultProps = {
  tag: null,
};

export default DeleteTagModal;
